export const MEMBER_ROLE = 30 as const
export const ADMIN_ROLE = 40 as const

export const roles: Record<number, string> = {
  [MEMBER_ROLE]: 'member',
  [ADMIN_ROLE]: 'admin',
}

export const getRoleLabel = (code: number): string => roles[code]
